import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = logged out

  useEffect(() => {
    api
      .get("/auth/me")
      .then((res) => setUser(res.data))
      .catch(() => setUser(false));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setUser(data);
    return data;
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch {
      // session may already be gone
    }
    setUser(false);
  };

  const switchWorkspace = async (workspaceId) => {
    const { data } = await api.post("/auth/switch-workspace", { workspace_id: workspaceId });
    setUser(data);
    return data;
  };

  const leaveWorkspace = async (workspaceId) => {
    const { data } = await api.post("/auth/leave-workspace", { workspace_id: workspaceId, base_url: window.location.origin });
    return data; // { status, workspace_name, next }
  };

  return (
    <AuthContext.Provider value={{ user, setUser, login, logout, switchWorkspace, leaveWorkspace }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
